import React from 'react';
import {NavLink} from "react-router-dom"
import styled from "styled-components";
import Nav from "./Nav";


const Header = () => {
    
  return (
    <MainHeader>
        <NavLink to="/">
            <img src="./images/CIANA.png" alt=""  className='logo'/>
        </NavLink>
       <Nav />
    </MainHeader>
  );
};

const MainHeader=styled.header`
    background-color: ${({ theme }) => theme.colors.bgl};
    padding:0 4.8rem;
    height:10rem;
    display:flex;
    justify-content:space-between;
    align-items:center;
    position:relative;

.logo{
    height:5.5rem;
    border:none;
   
}
@media (max-width: ${({ theme }) => theme.media.mobile}) {
padding:0 2rem;
height:7rem;


.logo{
    height:4.2rem;
   
}
}
`;



export default Header

